import styled from 'styled-components';

import { theme } from '../../../../styles/styled';

export const Title = styled.p<{ $fontSize?: string }>`
  margin-top: 0;
  font-weight: 500;
  font-size: ${(props): string => (props.$fontSize ? props.$fontSize : theme.constant.fontSize.standard)};
  line-height: ${theme.constant.gridPx(3)};
`;
